import { CoherenceDataGridColumn } from "@coherence-design-system/controls";
import { LocationConstants } from "./Locations";
import { Organization } from "../DataModels/Organization";

const getLocationDisplayName = (org: Organization): string => {
    let locationName = "";
    if (org.city) {
        locationName += `${org.city}, `;
    }
    if (org.state) {
        locationName += `${org.state}, `;
    }
    if (org.country) {
        locationName += `${LocationConstants.CountryRegionDisplayName[org.country]}`;
    }
    return locationName.trim();
};

export const OrgManagementGridColumns: Array<CoherenceDataGridColumn<Organization>> = [
    {
        key: "orgName",
        name: "Organization",
        fieldName: "name",
        type: "string",
        isResizable: true,
    },
    {
        key: "orgLocation",
        name: "Location",
        type: "string",
        isResizable: true,
        getValue: (org: Organization) => getLocationDisplayName(org),
    },
    {
        key: "orgDomains",
        name: "Domains",
        type: "string",
        isResizable: true,
        isMultiline: true,
        minColumnWidth: 250,
        getValue: (x: Organization) => x.domains?.map(value => value.domainName).join("; ") ?? "",
    },
    {
        key: "orgRoleTypes",
        name: "Role Types",
        type: "string",
        isResizable: true,
        isMultiline: true,
        minColumnWidth: 250,
        getValue: (x: Organization) => x.roleTypes?.map(value => value.roleName).join("; ") ?? "",
    },
];